(function(){
  'use strict';
  var FREE=4900;
  var money = function(c){ return (c/100).toFixed(2).replace('.',',') + ' €'; };
  var $ = function(s,r){ return (r||document).querySelector(s); };
  var $$ = function(s,r){ return Array.prototype.slice.call((r||document).querySelectorAll(s)); };

  function initReveal(){
    var els = $$('[data-reveal]:not(.is-in)');
    if(!('IntersectionObserver' in window)){ els.forEach(function(e){e.classList.add('is-in');}); return; }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){ if(en.isIntersecting){ en.target.classList.add('is-in'); io.unobserve(en.target);} });
    },{threshold:.12, rootMargin:'0px 0px -40px 0px'});
    els.forEach(function(e){ io.observe(e); });
  }

  function initHeader(){
    var h=$('.o-header'); if(h){ var onS=function(){ h.classList.toggle('is-scrolled', window.scrollY>10); }; onS(); window.addEventListener('scroll',onS,{passive:true}); }
    var m=$('.o-mnav');
    $$('[data-mnav-open]').forEach(function(b){ b.addEventListener('click',function(){ m&&m.classList.add('is-open'); document.body.style.overflow='hidden'; }); });
    $$('[data-mnav-close], .o-mnav a').forEach(function(b){ b.addEventListener('click',function(){ m&&m.classList.remove('is-open'); document.body.style.overflow=''; }); });
  }

  var GIFTS=(window.OlmaGifts||[]).map(Number);
  function isGift(it){ return GIFTS.indexOf(it.variant_id)>-1; }
  function tierOf(cart){
    var t=0;
    cart.items.forEach(function(it){ if(isGift(it)) return; var v=it.variant_title||''; t=Math.max(t,1); if(/^5 pots/i.test(v)) t=Math.max(t,3); else if(/^3 pots/i.test(v)) t=Math.max(t,2); });
    return t;
  }
  function syncGifts(cart){
    if(GIFTS.length<3) return Promise.resolve(cart);
    var t=tierOf(cart), want={}, upd={}, need=false;
    GIFTS.forEach(function(id,i){ want[id]= t>=i+1 ? 1 : 0; });
    GIFTS.forEach(function(id){ var q=0; cart.items.forEach(function(it){ if(it.variant_id===id) q+=it.quantity; }); if(q!==want[id]){ upd[id]=want[id]; need=true; } });
    if(!need) return Promise.resolve(cart);
    return fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({updates:upd})}).then(function(r){return r.json();}).catch(function(){ return cart; });
  }
  function renderShip(total){
    var el=$('[data-ship]'); if(!el) return;
    var left=FREE-total, pct=Math.max(4,Math.min(100,Math.round(total/FREE*100)));
    var txt=$('[data-ship-txt]',el), fill=$('.o-ship__fill',el);
    el.classList.toggle('is-done',left<=0);
    if(txt) txt.innerHTML = left<=0 ? '🎉 <span><b>Livraison offerte</b> débloquée !</span>' : '🚚 <span>Plus que <b>'+money(left)+'</b> pour la <b>livraison offerte</b></span>';
    if(fill) fill.style.width=(left<=0?100:pct)+'%';
  }

  var Cart = {
    open: function(){ document.body.classList.add('o-drawer-open'); },
    close: function(){ document.body.classList.remove('o-drawer-open'); },
    fetch: function(){ return fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}); },
    addOnly: function(items){
      return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:items})})
        .then(function(r){ if(!r.ok) return r.json().then(function(e){ throw e; }); return r.json(); });
    },
    add: function(items){ return Cart.addOnly(items).then(function(){ return Cart.refresh(true); }); },
    change: function(key,qty){
      return fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:key,quantity:qty})})
        .then(function(r){return r.json();}).then(syncGifts).then(function(c){ Cart.render(c); return c; });
    },
    refresh: function(openIt){ return Cart.fetch().then(syncGifts).then(function(c){ Cart.render(c); if(openIt) Cart.open(); return c; }); },
    render: function(cart){
      var paid=0; cart.items.forEach(function(it){ if(!isGift(it)) paid+=it.quantity; });
      $$('.o-cart-count').forEach(function(el){ el.textContent=paid; el.classList.toggle('has', paid>0); });
      var body=$('.o-drawer__body'), tot=$('[data-cart-total]'), foot=$('.o-drawer__foot'), ship=$('[data-ship]');
      if(!body) return;
      if(!paid){
        body.innerHTML='<div class="o-drawer__empty"><div style="font-size:44px">🌿</div><p>Votre panier est vide.</p><a class="o-btn" href="/products/haleine-fraiche">Découvrir Haleine Fraîche</a></div>';
        if(foot) foot.style.display='none'; if(ship) ship.style.display='none'; return;
      }
      if(foot) foot.style.display=''; if(ship) ship.style.display='';
      renderShip(cart.total_price);
      var html='';
      var giftHtml='';
      cart.items.forEach(function(it){
        if(isGift(it)){ var gi = it.image ? it.image + (it.image.indexOf('?')>-1?'&':'?') + 'width=120' : '';
          giftHtml+='<div class="o-gift"><div class="o-gift__ico">'+(gi?'<img src="'+gi+'" alt="" style="width:100%;height:100%;object-fit:cover;border-radius:10px">':'🎁')+'</div><div><b>'+it.variant_title+'</b><br>Cadeau offert, ajouté à votre colis</div><div style="margin-left:auto;font-weight:700;color:#0E7A59">Offert</div></div>'; return; }
        var img = it.image ? it.image + (it.image.indexOf('?')>-1?'&':'?') + 'width=160' : '';
        var opts = (it.options_with_values||[]).filter(function(o){return o.value!=='Default Title';}).map(function(o){return o.value;}).join(' · ');
        var plan = it.selling_plan_allocation ? '<div class="o-line__v">🔁 '+it.selling_plan_allocation.selling_plan.name+'</div>' : '';
        var orig = it.original_line_price>it.final_line_price ? '<s>'+money(it.original_line_price)+'</s>' : '';
        html+='<div class="o-line" data-key="'+it.key+'"><img src="'+img+'" alt=""><div><div class="o-line__t">'+it.product_title+'</div><div class="o-line__v">'+opts+'</div>'+plan+
          '<div class="o-qty"><button type="button" data-q="-1" aria-label="Retirer">−</button><span>'+it.quantity+'</span><button type="button" data-q="1" aria-label="Ajouter">+</button></div></div>'+
          '<div class="o-line__p">'+orig+money(it.final_line_price)+'</div></div>';
      });
      html+=giftHtml;
      var d=$('.o-drawer'); var up = d ? d.getAttribute('data-upsell-variant') : null;
      var single = cart.items.filter(function(it){ return /^1 pot/i.test(it.variant_title||'') && !it.selling_plan_allocation; })[0];
      if(single && up){
        html+='<div class="o-upsell"><p>💡 <b>Passez au pack 3 pots</b> : 1 pot offert, le fil dentaire en cadeau et la livraison offerte. Soit 23,27 € le pot au lieu de 34,90 €.</p><button type="button" data-upgrade="'+single.key+'" data-to="'+up+'">Passer au pack 3 pots · 69,80 €</button></div>';
      }
      body.innerHTML=html;
      if(tot) tot.textContent=money(cart.total_price);
    },
    init: function(){
      document.addEventListener('click',function(e){
        var t=e.target.closest('[data-cart-open]'); if(t){ e.preventDefault(); Cart.refresh(true); return; }
        if(e.target.closest('[data-cart-close]')){ Cart.close(); return; }
        var q=e.target.closest('[data-q]');
        if(q){ var line=q.closest('.o-line'); var cur=parseInt(line.querySelector('.o-qty span').textContent,10); Cart.change(line.getAttribute('data-key'), Math.max(0,cur+parseInt(q.getAttribute('data-q'),10))); return; }
        var u=e.target.closest('[data-upgrade]');
        if(u){ u.disabled=true; u.textContent='Mise à jour…'; Cart.change(u.getAttribute('data-upgrade'),0).then(function(){ return Cart.add([{id:parseInt(u.getAttribute('data-to'),10),quantity:1}]); }); return; }
        var a=e.target.closest('[data-add-variant]');
        if(a){ e.preventDefault(); var txt=a.innerHTML; a.innerHTML='Ajout…'; Cart.add([{id:parseInt(a.getAttribute('data-add-variant'),10),quantity:1}]).then(function(){a.innerHTML=txt;}).catch(function(){a.innerHTML=txt; window.location='/cart';}); }
      });
      document.addEventListener('keydown',function(e){ if(e.key==='Escape') Cart.close(); });
    }
  };
  window.OlmaCart = Cart;

  function initProduct(){
    var root=$('[data-olma-product]'); if(!root) return;
    var data=JSON.parse($('[data-olma-product-json]').textContent);
    var form=$('#OlmaForm',root), idIn=$('input[name="id"]',form), spIn=$('input[name="selling_plan"]',form);
    var atc=$('[data-atc]',root), buy=$('[data-buy-now]',root), atcPrice=$('.o-atc__price',root), sticky=$('.o-sticky'), stickyPrice=$('[data-sticky-price]');
    var gl=$('[data-giftline]',root);
    var variant=data.variants.filter(function(v){return v.id===data.selected;})[0]||data.variants[0];
    var planOn=false, first=true;
    var track=$('.o-gal__track',root), slides=$$('.o-gal__slide',root), thumbs=$$('.o-gal__thumbs button',root), dots=$$('.o-gal__dots i',root);
    function mark(i){ thumbs.forEach(function(t,k){t.classList.toggle('is-on',k===i);}); dots.forEach(function(t,k){t.classList.toggle('is-on',k===i);}); }
    function goTo(i){ if(!track||!slides[i]) return; track.scrollTo({left:slides[i].offsetLeft,behavior:'smooth'}); mark(i); }
    function cur(){ return track ? Math.round(track.scrollLeft/Math.max(1,track.clientWidth)) : 0; }
    function planAlloc(v){ if(!v.selling_plan_allocations||!v.selling_plan_allocations.length) return null; return v.selling_plan_allocations[0]; }
    function item(){ var it={id:parseInt(idIn.value,10),quantity:1}; if(spIn.value) it.selling_plan=parseInt(spIn.value,10); return it; }
    function update(){
      idIn.value=variant.id;
      var alloc=planAlloc(variant), price=variant.price;
      if(planOn && alloc){ spIn.value=alloc.selling_plan_id; price=alloc.price; } else { spIn.value=''; }
      spIn.disabled=!spIn.value;
      var p=money(price); if(atcPrice) atcPrice.textContent='· '+p; if(stickyPrice) stickyPrice.textContent=p;
      $$('[data-plan-price]',root).forEach(function(el){ var a=planAlloc(variant); el.textContent = a ? money(a.price) : ''; });
      $$('[data-once-price]',root).forEach(function(el){ el.textContent = money(variant.price); });
      var on=$('.o-bundle input:checked',root);
      if(gl && on){ var g=(on.getAttribute('data-gifts')||'').split('|').filter(Boolean);
        gl.innerHTML='<span class="ic">🎁</span><span><b>'+(g.length>1?g.length+' cadeaux offerts':'Cadeau offert')+'</b> dans votre colis<span class="o-giftline__list">'+g.map(function(x){return '<span>'+x+'</span>';}).join('')+'</span></span>'; }
      if(!first){ var url=new URL(window.location.href); url.searchParams.set('variant',variant.id); history.replaceState({},'',url.toString());
        var mi=variant.featured_media_index; if(typeof mi==='number' && mi>=0) goTo(mi); }
      first=false;
    }
    $$('.o-bundle input',root).forEach(function(inp){
      inp.addEventListener('change',function(){
        $$('.o-bundle',root).forEach(function(b){b.classList.remove('is-on');});
        inp.closest('.o-bundle').classList.add('is-on');
        variant=data.variants.filter(function(v){return v.id===parseInt(inp.value,10);})[0]; update();
      });
    });
    $$('.o-plan input',root).forEach(function(inp){
      inp.addEventListener('change',function(){
        $$('.o-plan',root).forEach(function(b){b.classList.remove('is-on');}); inp.closest('.o-plan').classList.add('is-on');
        planOn = inp.value==='sub'; update();
      });
    });
    form.addEventListener('submit',function(e){
      e.preventDefault(); atc.setAttribute('disabled',''); var lbl=$('.o-atc__lbl',atc), old=lbl.textContent; lbl.textContent='Ajout en cours…';
      Cart.add([item()]).then(function(){ lbl.textContent='Ajouté ✓'; setTimeout(function(){lbl.textContent=old;atc.removeAttribute('disabled');},1400); })
        .catch(function(){ form.submit(); });
    });
    if(buy) buy.addEventListener('click',function(){
      buy.setAttribute('disabled',''); var l=$('.o-buynow__lbl',buy); if(l) l.textContent='Redirection vers le paiement…';
      Cart.addOnly([item()]).then(function(){ return Cart.fetch().then(syncGifts); }).then(function(){ window.location.href='/checkout'; })
        .catch(function(){ window.location.href='/cart/'+variant.id+':1'; });
    });
    if(sticky && atc && 'IntersectionObserver' in window){ var sb=$('[data-sticky-btn]'); if(sb) sb.addEventListener('click',function(){ (buy||atc).click(); });
      var io=new IntersectionObserver(function(en){ sticky.classList.toggle('is-on', !en[0].isIntersecting && en[0].boundingClientRect.top<0); }); io.observe(atc); }
    thumbs.forEach(function(t,k){ t.addEventListener('click',function(){goTo(k);}); });
    var prev=$('.o-gal__arrow--p',root), next=$('.o-gal__arrow--n',root);
    if(prev) prev.addEventListener('click',function(){ goTo(Math.max(0,cur()-1)); });
    if(next) next.addEventListener('click',function(){ goTo(Math.min(slides.length-1,cur()+1)); });
    if(track) track.addEventListener('scroll',function(){ clearTimeout(track._t); track._t=setTimeout(function(){ mark(cur()); },80); },{passive:true});
    update();
  }

  function initNotify(){
    $$('form.o-notify').forEach(function(f){
      f.addEventListener('submit',function(e){
        e.preventDefault(); var fd=new FormData(f);
        fetch(f.action,{method:'POST',body:fd}).finally(function(){ var ok=document.createElement('div'); ok.className='o-notify-ok'; ok.textContent='✓ C’est noté, on vous prévient au lancement.'; f.replaceWith(ok); });
      });
    });
  }

  document.addEventListener('DOMContentLoaded',function(){
    initReveal(); initHeader(); Cart.init(); initProduct(); initNotify();
    Cart.refresh(false).catch(function(){});
    document.addEventListener('shopify:section:load',initReveal);
  });
})();